import MULTICALL_ABI from './abi.json';
import { ChainId } from '../chain';
import CONFIG from '../../config';

const MULTICALL_NETWORKS: { [chainId in ChainId]: string } = {
  [ChainId.MAINNET]: CONFIG.multicallNetChainId,
};

export { MULTICALL_ABI, MULTICALL_NETWORKS };
